export default [
  {
    group: "Overview",
    subgroups: [],
  },
  {
    group: "Get Started",
    subgroups: [
      "Sandbox Access",
      "Provider Access",
      "Payer Access",
      "Third Party Access",
      "Scopes",
    ],
  },
  {
      group:"Supported Capabilities",
      subgroups: ["Resources"]
     // subgroups: ["Resources", "System Operations"]
  },
  // {
  //     group:"Standards",
  //     subgroups: ["Identifier Systems", "Coding Systems"]
  // },
  // {
  //     group:"Mappings",
  //     subgroups: ["Elevance Health Concepts", "Import"]
  // },
  // {
  //     group:"Code Terms",
  //     subgroups: []
  // }
];
